<template>
	<v-container>
		<v-toolbar flat>2. Reitinhallinta</v-toolbar>
		<hr>
		Voit luoda uusia reittejä, muokata oo. reittejä sekä poistaa niitä. Katso video uuden reitin lisäämisestä seuraavalla sivulla
	</v-container>
</template>

<script>
	
	export default {
		name: 'routes',
	}

</script>